export const colors = [
  '#1763E5',
  '#B9D0F8',
  '#44C9C1',
  '#C7EFED',
  '#F6BD16',
  '#65789B',
  '#C2C8D5',
  '#F02FBD',
  '#FBE5A2',
  '#FFA3E7',
  '#13CEFF',
  '#B9F1FF',
  '#9661BC',
  '#D3C6EA',
  '#FF8800',
  '#FFD8B8',
  '#0ABB56',
  '#B6EBCC',
  '#004988',
  '#B2C9DC',
  '#FF5353',
  '#FFCCCC',
  '#7262FD',
  '#D3CEFD',
  '#8C8C47',
  '#DDDDC9',
  '#008685',
  '#AAD8D8',
  '#F872A9',
  '#FECAE0'
]

export const ssoLoginCodeErrConfig = {
  7: 'login.noCanSSO',
  8: 'login.noRegister'
}



// WEBPACK FOOTER //
// ./src/utils/config.js